export const BrandPrimaryColors = {
  "green": "#50C878",
  "orange": "#FB9A54",
  "blue": "#00C5FF"
}

export const BrandSecondaryColors = {
  "darkGreen": "#2D8F4E",
  "lighterGreen": "#73D393",
  "lightestGreen": "#B9E9C9",
  "white": "#FFFFFF"
}